import { useState } from "react";
import {
  CheckCircleIcon,
  ExclamationCircleIcon,
} from "@heroicons/react/24/outline";
import WarningModal from "../components-modals/WarningModal";
import { Form, Formik } from "formik";
import { object, string } from 'yup';
import { useSelector } from "react-redux";
import Cookies from "universal-cookie";
import { fetchApi } from "../tools";

const SeleccionUsuario = ({ handleContinuar, children, setContenido }) => {
  const cookies = new Cookies();
  //const url = cookies.get("__urlSchoolApi"); // url para enviar al api viene de cookies
  const urlState = useSelector(state => state.url.urlSchoolApi)
  const url = urlState === '' || urlState === undefined || urlState === null ? cookies.get("__urlSchoolApi") : urlState

  const { headersAPI: headers } = useSelector((state) => state.url); // Headers para enviar al api viene de redux
  const [modal, setModal] = useState({
    show: false,
    msg: "",
    ok: false,
  });
  const initialValues = {
    carnet: "",
  };

  const validationSchema = object({
    carnet: 
      string()
      .required(
        "Introduce una dirección de correo electrónico o un usuario válidos"
      ),
  });

  const sendCarnet = async (carnet) => {
    const res = await fetchApi({
      method: "GET",
      url: url + "/utils/buscarfamilia",
      headers,
      content: {
        Carnet: carnet,
      },
    });
    res.msg[0].Error === "1"
      ? setModal({
          show: true,
          msg: "El carnet ingresado no es válido, intente nuevamente",
          ok: false,
        })
      : setContenido(res.msg[0].Mensaje, "usuarioStep1");
  };
  // si todo va bien, envia
  const handleSubmit = (values) => {
    sendCarnet(values.carnet);
  };

  return (
    <>
      <WarningModal
        open={modal.show ? true : false}
        image={
          modal.ok ? (
            <CheckCircleIcon className="h-20 w-20 text-green-500 mx-auto" />
          ) : (
            <ExclamationCircleIcon className="h-20 w-20 text-red-500 mx-auto" />
          )
        }
        title="Aviso"
        subtitle={<span>{modal.msg}</span>}
        opacity="bg-opacity-50"
      >
        <div className="mt-5 sm:mt-6">
          <button
            onClick={() => {
              if (modal.reload) {
                window.location.reload();
              }
              setModal((curr) => ({
                ...curr,
                show: false,
                reload: false,
              }));
            }}
            type="button"
            className="inline-flex w-full justify-center rounded-md border border-transparent bg-azulBrillanteMira px-4 py-2 text-base font-medium text-white shadow-sm hover:bg-secundario transition duration-500 ease focus:outline-none sm:text-sm"
          >
            Entendido
          </button>
        </div>
      </WarningModal>
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={(values) => handleSubmit(values)}
      >
        {({ setFieldValue, values, resetForm, errors, touched }) => {
          return <Form>{children}</Form>;
        }}
      </Formik>
    </>
  );
};

export default SeleccionUsuario;
